// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AssignClients_mainWrapper__Pe2qh"};